import React, { useState, useEffect } from "react";
import useStyles from "../../settings/styles";
import config from "../../../config";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import InputComponent from "../../partner/components/inputComponent";
import InputDisable from "../../partner/components/inputDisable";
import InputDisableSimpleText from "../../user/components/inputDisableSimpleText";
import InputDecimal from "../../partner/components/inputDecimal";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { CircularProgress } from "@material-ui/core";
import Modal from "../../modals/Modal";
import SelectServicesAndDays from "./selectServiceAndDays";
import SnackbarMessage from "../../modals/SnackbarMessage";

export default function AddMembership() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{1,500}$/, // Letras
        textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
    }

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const classes = useStyles();
    const [membershipName, setMembershipName] = useState({ text: '', valid: null });
    const [description, setDescription] = useState({ text: '', valid: null });
    const [services, setServices] = useState({ text: [], valid: null });
    const [servicesAndDays, setServicesAndDays] = useState(null);
    const [servicesCost, setServicesCost] = useState({ text: '', valid: null });
    const [membershipType, setMembershipType] = useState({ text: '', valid: null });
    const [membershipValidity, setMembershipValidity] = useState('Vigencia');
    const [initTime, setInitTime] = useState('00:00');
    const [closeTime, setCloseTime] = useState('00:00');
    const [isOutOfDate, setIsOutOfDate] = useState(true);
    const [selectServicesKey, setSelectServicesKey] = useState(0);
    const [keyTable, setKeyTable] = useState(0);

    const [allServices, setAllServices] = useState([]);
    const [allMembershipType, setAllMembserhipType] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [showSnackbar, setShowSnackbar] = useState(false);
    const [messageSnackbar, setMessageSnackbar] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState(false);

    const handleToClose = (event, reason) => {
        if ("clickaway" == reason) return;
        setShowSnackbar(false);
    };

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250
            }
        },
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "center"
        },
        variant: "menu"
    };

    const fetchServices = async () => {
        if (!showModal) {
            fetch(baseUrl + "servicesAddMembership",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data.error == null) {
                        setAllServices(data);
                    } else {
                        setMessageSnackbar("Error al buscar servicios");
                        setErrorSnackbar(true);
                        setShowSnackbar(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchMembershipType = async () => {
        if (!showModal) {
            fetch(baseUrl + "membershipType",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data.error == null) {
                        setAllMembserhipType(data);
                    } else {
                        setMessageSnackbar("Error al buscar tipos de membresías");
                        setErrorSnackbar(true);
                        setShowSnackbar(true);
                    }
                }).catch(error => null);
        }
    }

    useEffect(() => {
        fetchServices();
        fetchMembershipType();
    }, []);

    const handleChange = (e) => {
        const value = e.target.value;

        if (value != '') {
            setMembershipType({ text: value, valid: 'true' });
            allMembershipType.map((item) => {
                if (item.name == value) {
                    setMembershipValidity(item.validity);
                }
            });
        } else {
            setMembershipType({ text: value, valid: 'false' });
            setMembershipValidity('Vigencia');
        }
    }

    const handleInitTimeChange = (event) => {
        setInitTime(event.target.value);
    };

    const handleCloseTimeChange = (event) => {
        setCloseTime(event.target.value);
    };

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);

        if (membershipName.valid === 'true' && services.valid === 'true' && membershipType.valid === 'true'
            && membershipValidity != 'Vigencia') {

            const newMembership = {
                membershipName: membershipName.text, description: description.text,
                services: servicesAndDays, membershipType: membershipType.text, membershipValidity: membershipValidity == 'Vigencia' ? 0 : membershipValidity,
                accessCount: membershipValidity, cost: servicesCost.text,
                initTime: initTime, closeTime: closeTime, isOutOfDate: isOutOfDate == true ? 1 : 0
            };

            const response = await fetch(baseUrl + "createMembership", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newMembership)
            });

            const json = await response.json();

            if (json.message == "Ok") {
                setMembershipName({ text: '', valid: null });
                setDescription({ text: '', valid: null });
                setServices({ text: [], valid: null });
                setServicesAndDays(null);
                setMembershipType({ text: '', valid: null });
                setMembershipValidity('Vigencia');
                setInitTime('00:00');
                setCloseTime('00:00');
                setServicesCost({ text: '', valid: null });
                setSelectServicesKey(selectServicesKey + 1);
                setKeyTable(keyTable + 1);
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }

    const valuesFromServicesComponent = (values) => {
        setServicesAndDays(values);
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}

            <SnackbarMessage
                showSnackbar={showSnackbar}
                messageSnackbar={messageSnackbar}
                handleToClose={handleToClose}
                isError={errorSnackbar}
            />

            <PageTitle title="Membrecía" />

            <div className={classes.divAddPage} >
                <div className={classes.divTitle}>
                    <label className={classes.titleStyle}>Agregar membrecía</label>
                </div>

                <div className={classes.divColumn} >
                    <InputComponent
                        text={membershipName}
                        setPartnerCode={setMembershipName}
                        type="text"
                        label="Nombre"
                        name="name"
                        regularExpression={expressions.textNumberAndSymbols}
                        placeholder="Nombre"
                        isRequired={true}
                    />

                    <InputComponent
                        text={description}
                        setPartnerCode={setDescription}
                        type="text"
                        label="Descripción"
                        name="description"
                        regularExpression={expressions.textNumberAndSymbols}
                        placeholder="Descripción corta"
                    />

                    {/*<div>
                        <label className={classes.label} >{"¿Tiene vigencia?"}</label>
                        <div className={classes.divSwitch}>
                            <p style={{ marginRight: "8px", fontSize: "16px", }}>No</p>
                            <Switch
                                checked={isOutOfDate}
                                onChange={handleSwitch}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                            <p style={{ marginLeft: "8px", fontSize: "16px", }}>Si</p>
                        </div>
                    </div>*/}

                    {isOutOfDate ? (
                        <>
                            <div>
                                <div className={classes.divLabel}>
                                    <p className={classes.label} >Tipo de membrecía</p>
                                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                                </div>

                                <FormControl className={classes.formControl}>
                                    <Select
                                        onChange={handleChange}
                                        displayEmpty
                                        value={membershipType.text}
                                        style={{ color: "#FFFFFF" }}
                                    >
                                        <MenuItem value=""> Selecciona </MenuItem>
                                        {allMembershipType.map((option) => (
                                            <MenuItem value={option.name}>{option.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <InputDisable
                                value={membershipValidity}
                                type="text"
                                label="Vigencia"
                                name="validity"
                                placeholder="Vigencia"
                            />
                        </>
                    ) : (
                        <></>
                    )}

                    <InputDisableSimpleText
                        value={membershipValidity}
                        type="text"
                        label="Número de accesos"
                        name="accessNumber"
                        placeholder="1"
                    />

                    <div className={classes.row}>
                        <div className={classes.divDate}>
                            <label className={classes.labelDate} >Hora de entrada</label>
                            <TextField
                                id="time"
                                type="time"
                                defaultValue="00:00"
                                className={classes.textFieldTime}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={initTime}
                                onChange={handleInitTimeChange}
                            />
                        </div>

                        <div className={classes.divDate}>
                            <label className={classes.labelDate} >Hora de salida</label>
                            <TextField
                                id="time"
                                type="time"
                                defaultValue="00:00"
                                className={classes.textFieldTime}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={closeTime}
                                onChange={handleCloseTimeChange}
                            />
                        </div>
                    </div>

                    <SelectServicesAndDays
                        text={services}
                        setValue={setServices}
                        services={allServices}
                        menuProps={MenuProps}
                        isRequired={true}
                        addValues={valuesFromServicesComponent}
                        key={selectServicesKey}
                        keyTable={keyTable}
                    />

                    <InputDecimal
                        text={servicesCost}
                        setPartnerCode={setServicesCost}
                        type="text"
                        label="Costo"
                        name="price"
                        placeholder="0.00"
                    />
                </div>

                <div className={classes.divButton}>
                    {isLoading ? (
                        <CircularProgress size={26} className={classes.loginLoader} />
                    ) : (
                        <button
                            className={isOutOfDate && membershipName.valid === 'true' && services.valid === 'true'
                                && membershipType.valid === 'true' && membershipValidity != 'Vigencia' ?
                                classes.enableButton : !isOutOfDate && membershipName.valid === 'true' && services.valid === 'true'
                                    ? classes.enableButton : classes.disableButton}
                            disabled={!(isOutOfDate ? membershipName.valid === 'true' && services.valid === 'true'
                                && membershipType.valid === 'true' && membershipValidity != 'Vigencia'
                                : membershipName.valid === 'true' && services.valid === 'true')}
                            onClick={onSubmit}
                        >Agregar</button>
                    )}
                </div>
            </div>
        </div>
    );
}
